import React from 'react';

const TrendsIcon = ({ backgroundFill, fillColor, strokeColor, strokeWidth, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      fill={backgroundFill}
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      width={width}
    >
      <polyline points="21.8 13.6 21.8 7 15.2 7 21.7 7 12.7 16 7.9 11.3 1.4 17.8" />
    </svg>
  );
};

export default TrendsIcon;
